import service from '@/store/services/workshop/vehicle_type-service';

const state = {
  list: {},
  vehicle_type: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, vehicle_type) => {
    state.vehicle_type = vehicle_type;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((vehicle_type) => { commit('SET_RESOURCE', vehicle_type); });
  },

  listByBrand({commit, dispatch}, params) {
    return service.listByBrand(params)
      .then((vehicle_type) => { commit('SET_RESOURCE', vehicle_type); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((vehicle_type) => { commit('SET_RESOURCE', vehicle_type); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((vehicle_type) => { commit('SET_RESOURCE', vehicle_type); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  vehicle_type: state => state.vehicle_type,
};
 
const vehicle_type = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default vehicle_type;
